import { render } from "./ImageCompressModal.vue?vue&type=template&id=34a0a1a8&scoped=true"
import script from "./ImageCompressModal.vue?vue&type=script&lang=js"
export * from "./ImageCompressModal.vue?vue&type=script&lang=js"

import "./ImageCompressModal.vue?vue&type=style&index=0&id=34a0a1a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a0a1a8"]])

export default __exports__